import { Box } from "@mui/material";
import React, { useState } from "react";
import { Translations } from "ui/Scripts/source/models/translations";
import { ISessionState } from "source/models/session/sessionState";
import { Dialog } from "../../../../framework/Dialog/Dialog";
import { DialogButtons } from "../../../../framework/Dialog/DialogButtons";
import { ITaskEditTypeItem } from "ui/Scripts/source/models/task/taskEditTypeItem";
import { ITaskDataRow, TaskDataRow } from "ui/Scripts/source/models/task/taskDataRow";
import { getTaskDataRowLine } from "source/components/task/TaskDataRowList";
import { List } from "source/components/framework/List/List";
import { ITaskDataRowCol, TaskDataRowCol } from "ui/Scripts/source/models/task/taskDataRowCol";
import { ChartTestDataRowDialog } from "./ChartTestDataRowDialog";

interface IChartTestDataDialogProps {
    sessionState: ISessionState;
    taskType: ITaskEditTypeItem;
    chartTestDataRows: ITaskDataRow[];
    onSave: (formDataRows: ITaskDataRow[]) => void;
    onClose: () => void;
}

export interface IChartTestDataDialogState {
    items: ITaskDataRow[];
    selectedId: string;
    showTaskDataRowDialog: boolean;
    editDialogItem: ITaskDataRow;
    editDialogHasPrevious: boolean;
    editDialogHasNext: boolean;
}

export const ChartTestDataDialog = (props: IChartTestDataDialogProps) => {
    const [state, setState] = useState<IChartTestDataDialogState>({
        items: props.chartTestDataRows.slice(0),
        selectedId: "",
        showTaskDataRowDialog: false,
        editDialogItem: null,
        editDialogHasPrevious: false,
        editDialogHasNext: false
    });

    const handleSetSelectedIds = (selectedId: string, _checkedIds: string[]) => {
        setState(old => ({
            ...old,
            selectedId
        }));
    };

    // #region Edit dialog
    const showEditDialog = (id: string) => {
        const index = state.items.findIndex(i => i.id === id);
        if (index < 0) return;
        setState(old => ({
            ...old,
            showTaskDataRowDialog: true,
            selectedId: id,
            editDialogItem: state.items[index],
            editDialogHasPrevious: index > 0,
            editDialogHasNext: index < state.items.length - 1
        }));
    };

    const setEditDialogItemByIndex = (index: number) => {
        if (index < 0) return;
        if (index >= state.items.length) return;
        setState(old => ({
            ...old,
            selectedId: state.items[index].id,
            editDialogItem: state.items[index],
            editDialogHasPrevious: index > 0,
            editDialogHasNext: index < state.items.length - 1
        }));
    };

    const handleEditDialogOk = (cols: ITaskDataRowCol[]) => {
        const index = state.items.findIndex(i => i.id === state.editDialogItem.id);
        if (index < 0) return;
        const newItem = new TaskDataRow(state.editDialogItem);
        newItem.cols = cols.map(i => new TaskDataRowCol(i));
        const items = state.items.slice(0);
        items[index] = newItem;
        setState(old => ({
            ...old,
            items,
            editDialogItem: items[index],
        }));
    };

    const handleOnRemove = (id: string) => {
        setState(old => ({
            ...old,
            selectedId: id === old.selectedId ? "" : old.selectedId,
            items: state.items.filter(i => i.id !== id)
        }));
    };

    const handleEditDialogCancel = () => {
        setState(old => ({
            ...old,
            showTaskDataRowDialog: false
        }));
    };

    const handleOpenLine = (id: string) => {
        if (!id) return;
        setState(old => ({
            ...old,
            selectedId: id
        }));
        showEditDialog(id);
    };
    // #endregion Edit dialog    

    const handleSave = async () => {
        props.onSave(state.items);
    };

    return (
        <Dialog
            id="chartGroupingFieldDialog"
            maxWidth="lg"
            maxHeight="400px"
            title={Translations.ChartTestData}
            body={
                <>
                    <Box height="100%" className="jsonFormLineData">
                        <List
                            intialized={true}
                            isLoading={false}
                            hasMore={false}
                            height="100%"
                            globalLoadingInUse={false}
                            header={{
                                columns: props.taskType.lineCols.map(i => {
                                    return { styleClass: "colTitleContainer " + i.class, column: i.field, content: i.title };
                                })
                            }}
                            lines={state.items.map((taskDataRow) => getTaskDataRowLine(props.sessionState, 0, taskDataRow, props.taskType))}
                            sortColumn={""}
                            sortOrderIsAsc={true}
                            selectedId={state.selectedId}
                            onSetSelectedIds={handleSetSelectedIds}
                            onSearchLines={(_sortColumn: string, _sortOrderIsAsc: boolean, nextPage: boolean) => {

                            }}
                            onOpenLine={handleOpenLine}
                        />
                    </Box>
                    {state.showTaskDataRowDialog &&
                        <ChartTestDataRowDialog
                            item={state.editDialogItem}
                            taskType={props.taskType}
                            hasPrevious={state.editDialogHasPrevious}
                            hasNext={state.editDialogHasNext}
                            onPrevious={() => List.moveToPrevious(state, setEditDialogItemByIndex)}
                            onNext={() => List.moveToNext(state, setEditDialogItemByIndex)}
                            onSaved={handleEditDialogOk}
                            onClose={handleEditDialogCancel}
                            onRemove={handleOnRemove}
                        />
                    }
                </>
            }
            actions={
                <Box display="flex" justifyContent="flex-end" width="100%">
                    <DialogButtons
                        saveTitle={Translations.OK}
                        onCancel={props.onClose}
                        onSave={handleSave}
                    />
                </Box>
            }
            onClose={props.onClose}
        />
    );
};
